// removed by extract-text-webpack-plugin
module.exports = {"loader":"y7M4QNUAM6NkZg1__UtWL_0"};


//////////////////
// WEBPACK FOOTER
// ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"extract":true,"remove":true}!./~/vue-style-loader!./~/css-loader?{"sourceMap":true,"localIdentName":"[hash:base64]_0","modules":true,"importLoaders":true}!./~/vue-loader/lib/style-rewriter.js?id=data-v-b96fa166!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Loader.vue
// module id = 65
// module chunks = 2